import { State, TabDisplayInterface, User, UserType } from '@wam/shared';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map, takeUntil } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';

@Injectable({
  providedIn: 'root',
})
export class AdminHomeTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);

  private destroyed$ = new Subject<void>();

  isFirst(): Observable<boolean> {
    const isFirst = true;

    return this.shouldShow().pipe(
      map((shouldShow: boolean) => shouldShow && isFirst),
      takeUntil(this.destroyed$),
    );
  }

  shouldShow(): Observable<boolean> {
    return this.store.pipe(
      select(authenticationSelectors.getCurrentUser),
      map((user: User) => user?.type === UserType.ADMIN),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
